import React from "react";
import PropTypes from "prop-types";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import NewsData from "../data/news.json";
import NewsItemContainer from "../containers/news/news-item";
import { slugify } from "../utils";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const NewsTag = ({
    match: {
        params: { slug },
    },
}) => {
    const data = NewsData.map((news) => {
        return {
            ...news,
            tags: news.tags.filter((tag) => slugify(tag) === slug),
        };
    }).filter((news) => news.tags.length > 0);
    const tagTitle = data?.length ? data[0].tags[0] : "";
    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title={
                        tagTitle +
                        " News | NeoGrowth - Lending simplified. Growth amplified."
                    }
                />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title={tagTitle}
                        excerpt=""
                        image="/images/banner/page/news.png"
                    />
                    <NewsItemContainer data={data} />
                    {/* <NewsletterArea /> */}
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

NewsTag.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            slug: PropTypes.string,
        }),
    }),
};

export default NewsTag;
